import Vue from 'vue'
import Vuex from 'vuex'
// 导入各个模块的state和mutations
import auth from './modules/auth'
import pwdreset from './modules/pwd-reset'
import orgmenus from './modules/orgmenus'
import sysmenus from './modules/sysmenus'
import orgstructure from './modules/orgstructure'
import orgroup from './modules/orgroup'
import dropdowns from './modules/dropdowns'
import users from './modules/users'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    pwdreset,
    orgmenus,
    sysmenus,
    orgstructure,
    orgroup,
    dropdowns,
    users
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js